export enum RISK_PROFILES_TABLE_KEYS {
  NAME = 'name',
  TITLE = 'title',
  UPDATED_AT = 'updatedAt',
}
